import { useState } from 'react';
import { hasRemoteImages } from '../../lib/mailHtml';
import type { MailMessageDto } from '../../lib/mailTypes';
import { MailAttachments } from './MailAttachments';
import { MailHtmlFrame } from './MailHtmlFrame';
import { MailLinks } from './MailLinks';

/** Body + attachments of one expanded message. HTML only ever goes into MailHtmlFrame. */
export function MailMessageBody({ threadId, message }: { threadId: string; message: MailMessageDto }) {
  const [loadImages, setLoadImages] = useState(false);
  const html = message.html?.trim() ? message.html : undefined;
  const blocked = !!html && !loadImages && hasRemoteImages(html);

  return (
    <div className="mail-message-body">
      {blocked && (
        <div className="mail-images-banner" role="status">
          <span>Remote images are blocked</span>
          <span aria-hidden> — </span>
          <button type="button" className="btn btn-xs" onClick={() => setLoadImages(true)}>
            Load images
          </button>
        </div>
      )}
      {html ? (
        <MailHtmlFrame
          html={html}
          allowRemoteImages={loadImages}
          title={`Message body from ${message.from.name || message.from.address}`}
        />
      ) : (
        // Plain text is a React text child — escaped, never parsed as HTML.
        <pre className="mail-text-body">{message.text}</pre>
      )}
      {html && <MailLinks html={html} />}
      <MailAttachments threadId={threadId} messageId={message.id} attachments={message.attachments} />
    </div>
  );
}
